<template>
  <BoxWithTitle>
    <template v-slot:header>
      <v-toolbar-title>
        {{ $t('contacts.contactInfo') }}
      </v-toolbar-title>
    </template>
    <template v-slot:icons>
      <v-btn
        v-if="hasPermission('contacts.edit')"
        icon
        class="edit__contact"
        @click="onClickToggle"
      >
        <v-icon>
          {{ formEditable ? 'mdi-close' : 'mdi-pencil-outline' }}
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:content>
      <form>
        <ContactForm
          ref="mainForm"
          :populateWith="updatedData"
          :isEditable="formEditable"
          @dirtyChanged="isFormDirty = $event"
          @validChanged="isFormValid = $event"
          @sendData="updateData"
        />
        <v-row
          v-if="formEditable"
          align="center"
          justify="end"
          class="mr-1"
        >
          <v-btn
            v-if="hasPermission('contacts.remove')"
            text
            @click="onClickConfirmRemove"
          >
            <span class="text-danger">
              {{ $t('forms.btn.delete') }}
            </span>
          </v-btn>
          <v-btn
            :disabled="!isFormValid || !isFormDirty"
            type="submit"
            color="secondary"
            @click.prevent="onClickUpdate"
          >
            {{ $t('forms.btn.save') }}
          </v-btn>
        </v-row>
      </form>
    </template>
  </BoxWithTitle>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ContactForm from '@/components/forms/ContactForm.vue';
import FormPageMixin from '@/mixins/FormPageMixin';
import BoxWithTitle from '@/components/shared/containers/VBoxWithTitle.vue';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';

export default {
    components: {
        ContactForm,
        BoxWithTitle,
    },
    mixins: [
        FormPageMixin,
    ],
    data() {
        return {
            updatedData: null,
        };
    },
    computed: {
        ...mapGetters([
            'contact',
            'hasPermission',
        ]),
        defaultData() {
            return this.contact;
        },
    },
    methods: {
        ...mapActions({
            reloadContact: 'getContactInfo',
            resetContact: 'resetContactInfo',
        }),
        async onClickUpdate() {
            const { id, firstName, lastName } = this.updatedData;
            await this.$rq.updateContact(id, this.updatedData);

            this.$toasted.global.toast_success({
                message: this.$t('msg.contactModified', {
                    data: `${firstName} ${lastName}`,
                }),
            });
            this.formEditable = false;
            this.reloadContact(id);
        },
        async removeRequest() {
            const { id, firstName, lastName } = this.updatedData;
            await this.$rq.deleteContact(id);

            this.$toasted.global.toast_success({
                message: this.$t('msg.contactDeleted', {
                    data: `${firstName} ${lastName}`,
                }),
            });

            this.resetContact();
            this.redirectToList();
        },
        onClickConfirmRemove() {
            this.$root.$emit('showModal', {
                title: this.$t('contacts.removeContact'),
                component: Vue.component('ConfirmForm', ConfirmForm),
                payload: { msg: this.$t('contacts.confirmRemove') },
                onConfirm: this.removeRequest.bind(this),
                isForm: false,
            });
        },
        /**
         * Redirect to the right contacts page
         */
        redirectToList() {
            const { clientId, siteId } = this.$route.params;
            const params = { clientId };
            let name = 'contacts';

            if (siteId) {
                name = 'siteContacts';
                params.siteId = siteId;
            }

            this.$router.push({ name, params });
        },
    },
};
</script>
